import React from 'react';
import { MCButton } from 'src/components/basic';
import { lang } from 'src/helpers';
import LANG_CONST from 'src/helpers/lang/const';

const NavigationButtons = ({ loading, prev, next, labelNext = 'Next' }) => (
  <>
    <div style={{ flex: 1 }} />
    <div className={'mc-flex-15 mc-mt30'}>
      <div className={'mc-grow'} />
      {!!prev && (
        <MCButton primary medium light radius onClick={prev}>
          {lang.t(LANG_CONST.buttons.previous)}
        </MCButton>
      )}
      <MCButton primary medium dark radius disabled={loading} loading={loading} onClick={next}>
        {lang.t(labelNext)}
      </MCButton>
    </div>
  </>
);

export default NavigationButtons;
